// extracted by mini-css-extract-plugin
module.exports = {"anchor":"markdown-anchor_anchor__lBAV_","container":"markdown-anchor_container__0qZni"};